// Profile completion validation utilities

export const checkProfileCompletion = (user) => {
  const requirements = {
    personal: {
      required: ['first_name', 'last_name', 'email', 'phone_number', 'id_number', 'address', 'city', 'province', 'postal_code'],
      completed: [],
      missing: []
    },
    education: {
      required: ['highest_grade', 'school_name'],
      completed: [],
      missing: []
    },
    location: {
      required: ['latitude', 'longitude'],
      completed: [],
      missing: []
    }
  };

  // Check personal information
  requirements.personal.required.forEach(field => {
    if (user && user[field] && user[field].toString().trim() !== '') {
      requirements.personal.completed.push(field);
    } else {
      requirements.personal.missing.push(field);
    }
  });

  // Check education information
  requirements.education.required.forEach(field => {
    if (user && user[field] && user[field].toString().trim() !== '') {
      requirements.education.completed.push(field);
    } else {
      requirements.education.missing.push(field);
    }
  });

  // Check location information
  requirements.location.required.forEach(field => {
    if (user && user[field] && user[field] !== null) {
      requirements.location.completed.push(field);
    } else {
      requirements.location.missing.push(field);
    }
  });

  // Calculate completion percentages
  const personalCompletion = (requirements.personal.completed.length / requirements.personal.required.length) * 100;
  const educationCompletion = (requirements.education.completed.length / requirements.education.required.length) * 100;
  const locationCompletion = (requirements.location.completed.length / requirements.location.required.length) * 100;
  
  const overallCompletion = (personalCompletion + educationCompletion + locationCompletion) / 3;

  // Determine if profile is complete enough for course applications
  const canApplyForCourses = personalCompletion >= 80 && educationCompletion >= 100 && locationCompletion >= 100;

  return {
    requirements,
    completion: {
      personal: Math.round(personalCompletion),
      education: Math.round(educationCompletion),
      location: Math.round(locationCompletion),
      overall: Math.round(overallCompletion)
    },
    canApplyForCourses,
    missingForApplication: {
      personal: requirements.personal.missing,
      education: requirements.education.missing,
      location: requirements.location.missing
    }
  };
};

export const getProfileCompletionMessage = (profileCheck) => {
  if (profileCheck.canApplyForCourses) {
    return {
      type: 'success',
      title: 'Profile Complete',
      message: 'Your profile is complete and you can apply for courses.'
    };
  }

  const messages = [];
  
  if (profileCheck.completion.personal < 80) {
    messages.push('Complete your personal information including address and postal code');
  }
  
  if (profileCheck.completion.education < 100) {
    messages.push('Add your school results and educational background');
  }
  
  if (profileCheck.completion.location < 100) {
    messages.push('Share your location for economic corridor allocation');
  }

  return {
    type: 'warning',
    title: 'Profile Incomplete',
    message: 'To apply for courses, please:',
    requirements: messages
  };
};

export const getFieldDisplayName = (fieldName) => {
  const fieldNames = {
    first_name: 'First Name',
    last_name: 'Last Name',
    email: 'Email Address',
    phone_number: 'Phone Number',
    id_number: 'ID Number',
    address: 'Street Address',
    city: 'City',
    province: 'Province',
    postal_code: 'Postal Code',
    highest_grade: 'Highest Grade Completed',
    school_name: 'School Name',
    latitude: 'GPS Location',
    longitude: 'GPS Location'
  };
  
  return fieldNames[fieldName] || fieldName;
};
